// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RadioGroup-base__DvBVi{display:flex;flex-direction:column;gap:var(--size-2_5)}.RadioGroup-horizontal__GeaRo{flex-direction:row;gap:var(--size-2_5)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "RadioGroup-base__DvBVi",
	"horizontal": "RadioGroup-horizontal__GeaRo"
};
export default ___CSS_LOADER_EXPORT___;
